import { useMemo } from 'react';
import { CustomCaptionFields, CustomContent, FieldOptionsWithRouter } from '../types';
import {
  getComplexContentObjectArray,
  getContentBlockField,
  getPlaceholderForPreview
} from '../utils';

export const useContentBlockCaptions = (
  customContent: CustomContent[],
  { slug, router }: FieldOptionsWithRouter
) => {
  return useMemo<CustomCaptionFields[]>(() => {
    const content =
      getComplexContentObjectArray<CustomCaptionFields>(
        getContentBlockField(customContent, 'captions', { slug })
      ) || [];

    return content.reduce((acc, i, index) => {
      const item = {
        text: i.text || getPlaceholderForPreview(router, `Caption ${index + 1}`, '')
      };
      if (item.text) {
        acc.push(item);
      }
      return acc;
    }, [] as CustomCaptionFields[]);
  }, [customContent, router, slug]);
};
